import { useState } from "react";
import DatePicker from "react-datepicker";
import { Col, Input, Label } from "reactstrap";
import { Mail, Notification, RemindOn } from "../../Constant";

export const TaskRadioRow = () => {
  const timeList = ["7:00 am", "7:30 am", "8:00 am", "8:30 am", "9:00 am", "9:30 am", "10:00 am", "10:30 am", "11:00 am", "11:30 am", "12:00 am", "12:30 am", "1:00 pm", "2:00 pm", "3:00 pm", "4:00 pm"];

  const [startDate, setStartDate] = useState<Date | null>(new Date());
  const handleChange = (date: Date | null) => setStartDate(date);
  return (
    <Col md="12" className="mb-3 mt-0">
      <div className="d-flex date-details">
        <div className="d-inline-block">
          <Label className="d-block mb-0" htmlFor="chk-ani" check>
            <input className="checkbox_animated" id="chk-ani" type="checkbox" />
            {RemindOn}
          </Label>
        </div>
        <div className="d-inline-block">
          <DatePicker className="form-control flatpickr-input is-valid" selected={startDate} onChange={handleChange} />
        </div>
        <div className="d-inline-block">
          <Input type="select" className="is-valid">
            {timeList.map((item, index) => (
              <option key={index}>{item}</option>
            ))}
          </Input>
        </div>
        <div className="d-inline-block">
          <Label className="d-block mb-0" for="chk-ani1" check>
            <input className="checkbox_animated" id="chk-ani1" type="checkbox" />
            {Notification}
          </Label>
        </div>
        <div className="d-inline-block">
          <Label className="d-block mb-0" for="chk-ani2" check>
            <input className="checkbox_animated" id="chk-ani2" type="checkbox" />
            {Mail}
          </Label>
        </div>
      </div>
    </Col>
  );
};
